import React from "react";
import Hero from "../trimurti/Hero";
import TheGreatSage from "../trimurti/TheGreatSage";
import FinalSpiritual from "../trimurti/FinalSpiritual";
import SahajYogaCard from "../common/SahajYogaCard";
import HeaderOnly from "../common/HeaderOnly";
import Footer from "../common/Footer";
const Trimurti = () => {
  return (
    <>
      <HeaderOnly />
      <TheGreatSage />
      <FinalSpiritual />
      <SahajYogaCard />
      <Footer />
    </>
  );
};

export default Trimurti;
